import React from "react";
import Accordion from 'react-bootstrap/Accordion';
import './faqs.css';

const Faqs = () => {
    return (
        <React.Fragment>
            <div className="faqs_main">
                <div className="faqs_title_sec">
                    <h2>FAQs</h2>
                </div>
                <div className="container">
                    <Accordion defaultActiveKey="0">
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>1.General Questions</Accordion.Header>
                            <Accordion.Body>

                                <div className="inner_accordian_main">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Q1: What types of courses are offered on Finlabs Learning Hub?</Accordion.Header>
                                            <Accordion.Body>
                                            Finlabs Learning Hub offers a diverse range of courses designed to cater to various professional needs. Whether you're interested in finance, personal development, leadership, IT, or other key areas, we provide high-quality, expert-led courses to help you grow and excel in your career.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>Q2: Can I create and share my own courses on Finlabs Learning Hub?</Accordion.Header>
                                            <Accordion.Body>
                                            While our courses are curated by selected industry professionals to ensure top-notch quality, we are always on the lookout for fresh, expert perspectives! If you have the expertise to create specialized content, we'd love to hear from you. Please write to us at <a href="mailto: info@finlabsindia.com"><i>info@finlabsindia.com</i></a> to discuss potential collaboration opportunities.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header>Q3: Who can benefit from using Finlabs Learning Hub?</Accordion.Header>
                                            <Accordion.Body>
                                            Finlabs Learning Hub is ideal for: <br/><br/>

 

                                                Individuals: Professionals and growth-oriented individuals looking to upskill, gain certifications, and advance their careers. 

                                                Organizations: Companies and corporate teams seeking to enhance their workforce's skills and drive business outcomes. 

                                                HR and Learning & Development Managers: Those responsible for creating effective training programs to foster continuous learning and development within their teams.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3">
                                            <Accordion.Header>Q4: Can I access courses from multiple devices?</Accordion.Header>
                                            <Accordion.Body>
                                            Yes, you can access all courses on Finlabs Learning Hub from any device with an internet connection, including desktops, laptops, tablets, and smartphones.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="4">
                                            <Accordion.Header>Q5: What if I encounter technical issues or need help with a course?</Accordion.Header>
                                            <Accordion.Body>
                                            Our support team is here to help you with any technical issues or course-related queries. You can reach out to us via email <a href="mailto: Info@finlabsindia.com"><i>Info@finlabsindia.com</i></a> 
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="5">
                                            <Accordion.Header>Q6: Are there additional resources available to aid my learning?</Accordion.Header>
                                            <Accordion.Body>
                                            Yes, each course includes supplementary materials such as articles, videos, quizzes, etc to enhance your learning experience. 
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="6">
                                            <Accordion.Header>Q7: Can organizations track the progress of their employees?</Accordion.Header>
                                            <Accordion.Body>
                                            Yes, our platform provides tools for organizations to monitor and track employee progress, completion rates, and performance metrics in real-time. 
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="7">
                                            <Accordion.Header>Q8: How can I stay updated on new courses and offers?</Accordion.Header>
                                            <Accordion.Body>
                                            You can stay updated by <a href = "#info">subscribing</a> to our newsletter and following us on social media to receive the latest news, updates, and special offers. 
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="8">
                                            <Accordion.Header>Q9: Is there a community or forum where I can interact with other learners?</Accordion.Header>
                                            <Accordion.Body>
                                            Currently, we do not have a dedicated community or forum. However, we're always exploring new ways to enhance our platform. Stay tuned—you never know what exciting features might be added next! 
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>

                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="1">
                            <Accordion.Header>2.Enrollment and Access</Accordion.Header>
                            <Accordion.Body>
                            <div className="inner_accordian_main">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Q10: How do I enroll in a course?</Accordion.Header>
                                            <Accordion.Body>
                                            Enrolling in a course is simple and straightforward!<br/><br/>

 

                                            For Individuals: Just register on our platform and purchase the courses of your choice to start learning immediately. 

                                            For Organizations: Share your specific requirements with us <a href = "/EnquiryForm"> here</a>, and we will work with you to provide a customized training solution tailored to your team's needs. 

                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>Q11: Is there a time limit to complete a course?</Accordion.Header>
                                            <Accordion.Body>
                                            Our platform is designed with flexibility in mind. While some courses may have a completion time limit to ensure you stay on track, many others are self-paced, allowing you to learn at your own convenience. We believe in offering learning options that suit your schedule and pace.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="2">
                            <Accordion.Header>3.Pricing and Payments</Accordion.Header>
                            <Accordion.Body>
                            <div className="inner_accordian_main">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Q12: How much do the courses cost?</Accordion.Header>
                                            <Accordion.Body>
                                            Course prices vary depending on the topic and content. We offer competitive pricing to ensure accessibility and affordability. Visit the <a href = "#course"> Course Page</a> to see specific pricing details. 

                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>Q13: Are there discounts available for group enrollments?</Accordion.Header>
                                            <Accordion.Body>
                                            Yes, we offer special group discounts for organizations looking to enroll multiple team members. Please fill out our <a href = "/GeneralEnquiry"> Enquiry</a> form to request a group discount.
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2">
                                            <Accordion.Header>Q14: What payment methods are accepted?</Accordion.Header>
                                            <Accordion.Body>
                                            We accept all major credit and debit cards, Net banking, wallet pay etc. And for organizations, we also offer invoicing options for bulk purchases. 
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>

                        <Accordion.Item eventKey="3">
                            <Accordion.Header>4.Certifications and Accreditation</Accordion.Header>
                            <Accordion.Body>
                            <div className="inner_accordian_main">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>Q15: Will I receive a certificate after completing a course?</Accordion.Header>
                                            <Accordion.Body>
                                            Yes, upon successful completion of a course, you will receive a digital certificate at no additional cost, which you can download and add it to your resume or LinkedIn profile. 

                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1">
                                            <Accordion.Header>Q16: Are the courses accredited?</Accordion.Header>
                                            <Accordion.Body>
                                            While our courses are curated by industry experts and widely recognized in professional circles, they are not accredited by traditional educational institutions. However, they provide valuable skills and knowledge that are highly regarded in the industry. 
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                            </div>
                            </Accordion.Body>
                        </Accordion.Item>

                    </Accordion>
                </div>
            </div>
        </React.Fragment>
    )
}

export default Faqs;